import React, { useCallback, useEffect, useState } from 'react'
import TableCustom from '../../../../components/table/tableCustom';
import { ButtonBack, ButtonPrimary } from '../../../../components/button/ButtonCustoms';
import ContentHeading from '../../../../components/layout/content/ContentHeading';
import InputTextField from '../../../../components/input/inputTextField';
import { RemoveRedEyeOutlined, SearchOutlined } from '@mui/icons-material';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import TableRowCommon from '../../../../components/table/TableRowCommon';
import { dateTimeToView } from '../../../../utils/date.utils';
import SwitchCustom from '../../../../components/switch/SwitchCustom';
import { useDispatch } from 'react-redux';
import ModalCustom from '../../../../components/modal/ModalCustom';
import { alertActive, swalError, swalSuccess } from '../../../../components/alert/swal';
import OptionsButtonCustom from '../../../../components/button/OptionsButtonCustom';
import { MeetingTypeApi } from '../../../../api/meeting-type/meeting-type.api';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { useTranslation } from 'react-i18next';

const defaultState = {
    id_meeting_type: 0,
    meeting_type_name: undefined,
    meeting_type_desc: undefined,
}
export default function ManageMeetingCategories() {
    const navigate: NavigateFunction = useNavigate();
    const { t } = useTranslation();
    const [data, setData] = useState<any[]>([]);
    const dispatch = useDispatch();
    const [search, setSearch] = useState<any>('')
    const [form, setForm] = useState<any>(defaultState)
    const [type, setType] = useState<string>("CREATE");

    const [open, setOpen] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const headCells = [
        {
            id: "#",
            width: '80px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: "#",
        },
        {
            id: "leave_type_name",
            width: '300px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("MEETING_CATEGORY.MEETING_CATEGORY_NAME"),
        },
        {
            id: "status",
            disablePadding: false,
            width: '100px',
            sortable: false,
            align: "start",
            label: t("MEETING_CATEGORY.STATUS"),
        },
        {
            id: "user_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("MEETING_CATEGORY.LAST_UPDATED_BY"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("MEETING_CATEGORY.LAST_UPDATED_DATE"),
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '100px',
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const { id_meeting_type, meeting_type_name, status, modifier_name, modified_date } =
            objData;

        const objRenderData = {
            key: id_meeting_type,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: no || "-",
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: meeting_type_name,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <SwitchCustom
                            checked={status === "active" ? true : false}
                            onChange={(value: boolean) => {
                                  handleUpdateStatus(id_meeting_type, value ? "active" : "inactive");
                            }}
                        />
                    ),
                },
                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: modifier_name || '-',
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateTimeToView(modified_date) : "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <OptionsButtonCustom
                            enableView
                            enableEdit
                            enableDelete
                            onViewClick={() => {
                                setOpen(true)
                                // getDetail(id_course_of_study)
                                setForm(objData)
                                setType("VIEW")
                            }}

                            onEditClick={() => {
                                setOpen(true)
                                // getDetail(id_course_of_study)
                                setForm(objData)
                                setType("EDIT")
                            }}
                            onDeleteClick={() => {
                                alertActive(t('ยืนยันที่จะลบ หรือไม่?'), '', t('ยืนยัน'), t('ยกเลิก'), () => {
                                    handleDelete(id_meeting_type)
                                })
                            }} />
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };

    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (search) condition = { ...condition, keyword: search };

            const res = await MeetingTypeApi.list(condition);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit, search]);

    useEffect(() => {
        loadData();
    }, [loadData]);
    const handleClose = async () => {
        setOpen(false)
        setForm(defaultState)
    }

    const handleUpdateStatus = async (id_meeting_type:number, status:any) => {
        await MeetingTypeApi.patch({status: status}, id_meeting_type).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('MEETING_CATEGORY.EDIT_MEETING_CATEGORY_SUCCESS'))
                loadData()
                handleClose()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
        })
    }
    const handleCreate = async () => {
        const body = {
            meeting_type_name: form?.meeting_type_name,
            meeting_type_desc: form?.meeting_type_desc,
            status: "active"
        };
        if (type === 'EDIT') {
            await MeetingTypeApi.patch(body, form.id_meeting_type).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('MEETING_CATEGORY.EDIT_MEETING_CATEGORY_SUCCESS'))
                    loadData()
                    handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
            })

        } else {
            await MeetingTypeApi.post(body).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('MEETING_CATEGORY.ADD_MEETING_CATEGORY_SUCCESS'))
                    loadData()
                    handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
            })

        }
    }

    const handleDelete = async (id: any) => {
        await MeetingTypeApi.delete(id).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('MEETING_CATEGORY.DELETE_MEETING_CATEGORY_SUCCESS'))
                loadData()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
        })

    }
    return (
        <div>
            <ContentHeading
                title={t("MEETING_CATEGORY.MANAGE_MEETING_CATEGORY")}
                detail={t("MEETING_CATEGORY.PLEASE_SELECT_OPTION")}
            />

            <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12">
                    <InputTextField
                        startAdornment={<SearchOutlined />}
                        placeholder={t("MEETING_CATEGORY.SEARCH_MEETING_CATEGORY")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                            setSearch(e.target.value)
                        }}
                        value={search || ''}
                    />
                </article>

                <article
                    className="w-full col-span-12 md:col-span-4 lg:col-span-9 sm:col-span-12"
                    style={{
                        display: "flex",
                        justifyContent: "end",
                    }}
                >
                    <ButtonPrimary
                        onClick={() => {
                            // navigate(routeName.cms.ManageLeaveType + `/create`);
                            setOpen(true)
                            setType('CREATE')
                        }}
                        mode="add"
                        buttonName={t("MEETING_CATEGORY.ADD_MEETING_CATEGORY")}
                    />
                </article>
            </div>

            <section className="w-full mt-10">
                <TableCustom
                    tableMinWidth={1440}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>
            <ModalCustom title={type === 'CREATE' ? t('MEETING_CATEGORY.ADD_MEETING_CATEGORY_SUCCESS') : t('MEETING_CATEGORY.MEETING_CATEGORY_INFO')} subTitle={t('MEETING_CATEGORY.PLEASE_PROVIDE_COMPLETE_INFO')} open={open} component={
                <div className='flex flex-col gap-4'>

                    <div>
                        <InputTextField
                            heading={t("MEETING_CATEGORY.MEETING_CATEGORY_NAME_LABEL")}
                            placeholder={t("MEETING_CATEGORY.SPECIFY_MEETING_CATEGORY_NAME")}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                // handleChangeValueSearch("leave_type_name", e.target.value);
                                setForm({ ...form, meeting_type_name: e.target.value })
                            }}
                            value={form.meeting_type_name}
                            disabled={type === 'VIEW'}
                        />
                    </div>
                    <div>
                        <InputTextField
                            heading={t("MEETING_CATEGORY.DETAILS")}
                            placeholder={t("MEETING_CATEGORY.DETAILS")}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                // handleChangeValueSearch("leave_type_name", e.target.value);
                                setForm({ ...form, meeting_type_desc: e.target.value })
                            }}
                            value={form.meeting_type_desc}
                            multiline
                            minRow={6}
                            inputHeight={'auto'}
                            disabled={type === 'VIEW'}
                        // value={inputValueSearch.leave_type_name}
                        />
                    </div>
                    <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                handleClose()
                            }}
                            buttonName={t('ยกเลิก')}
                        />
                        {type !== 'VIEW' && <ButtonPrimary
                            onClick={() => {
                                handleCreate()
                            }}
                            mode='add'
                            disabled={!form.meeting_type_name}
                            buttonName={t('ยืนยัน')}
                        />}
                    </div>
                </div>
            } />
        </div>
    )
}
